import "./portfolio.scss"
import Gallery from '../../components/gallery/gallery';

function Portfolio() {
  return (
    
    <div className="fotogallery">
    <Gallery folder="portfolio_foto" />
    </div>
  );
}

export default Portfolio;